module.exports = __webpack_public_path__ + "9a134a38a0523bc490b87f3bce674b25.png";